import React, { ButtonHTMLAttributes } from 'react'

import PropTypes from 'prop-types'

import { Opcao } from './styles'

export const MenuContextoOpcao: React.FC<
  ButtonHTMLAttributes<HTMLButtonElement>
> = ({ children, ...rest }) => {
  return <Opcao {...rest}>{children}</Opcao>
}

MenuContextoOpcao.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired
}
